import React, { useRef, useEffect, useContext, useCallback } from 'react';
import { ThemeContext } from '../../Contaxt/ThemeContext';
import Spline from '@splinetool/react-spline';
import VectorLineDots from '../Common/VectorLineDots';
import { getScrollableHeight, getScrollTop, scrollToPosition } from '../../utils/scrollContainer';

const Banner = () => {
    const { isLight } = useContext(ThemeContext);
    const audioRef = useRef(null);
    const scrollAnimationRef = useRef(null);
    const isScrollingRef = useRef(false);
    const outsideClickHandlerRef = useRef(null);
    const [showSpline, setShowSpline] = React.useState(false);

    const stopAudio = useCallback(() => {
        if (!audioRef.current) return;

        audioRef.current.pause();
        audioRef.current.currentTime = 0;
    }, []);

    const stopAutoScroll = useCallback(() => {
        isScrollingRef.current = false;

        if (scrollAnimationRef.current) {
            cancelAnimationFrame(scrollAnimationRef.current);
            scrollAnimationRef.current = null;
        }

        stopAudio();

        if (outsideClickHandlerRef.current) {
            window.removeEventListener('wheel', outsideClickHandlerRef.current);
            window.removeEventListener('touchmove', outsideClickHandlerRef.current);
            window.removeEventListener('keydown', outsideClickHandlerRef.current);
            outsideClickHandlerRef.current = null;
        }
    }, [stopAudio]);

    const handlePlayClick = useCallback(() => {
        // Cancel any ongoing scroll
        stopAutoScroll();

        // Small delay to ensure DOM is ready
        setTimeout(() => {
            const totalHeight = getScrollableHeight();

            if (totalHeight <= 0) {
                console.warn("Page not scrollable yet");
                return;
            }

            const duration = 65000;
            const startTime = performance.now();
            const startY = getScrollTop();

            isScrollingRef.current = true;
            audioRef.current?.play().catch(() => { });

            const scrollStep = (currentTime) => {
                if (!isScrollingRef.current) return;

                const elapsed = currentTime - startTime;
                const progress = Math.min(elapsed / duration, 1);
                const nextY = startY + (totalHeight - startY) * progress;

                scrollToPosition(nextY);

                if (progress < 1) {
                    scrollAnimationRef.current = requestAnimationFrame(scrollStep);
                } else {
                    stopAutoScroll();
                }
            };

            scrollAnimationRef.current = requestAnimationFrame(scrollStep);

            // Stop on manual interaction
            const stopScroll = () => {
                stopAutoScroll();
            };

            outsideClickHandlerRef.current = stopScroll;
            window.addEventListener('wheel', stopScroll);
            window.addEventListener('touchmove', stopScroll);
            window.addEventListener('keydown', stopScroll);

        }, 100);

    }, [stopAutoScroll]);

    useEffect(() => {
        return () => {
            stopAutoScroll();
        };
    }, [stopAutoScroll]);


    useEffect(() => {
        const t = setTimeout(() => setShowSpline(true), 100);
        return () => clearTimeout(t);
    }, []);

    /* ================= JSX ================= */

    return (

        <div
            className={`fw-main-row black-bg-content ${isLight ? 'banner-light' : 'banner-dark'}`}
        >
            {isLight && (
                <>
                    <img src='/images/banner_left_element.webp' alt='' className='banner_left_element' />
                    <img src='/images/banner_right_element.webp' alt='' className='banner_right_element' />
                </>
            )}

            <div className="fw-full-container-top" style={{ backgroundImage: 'url(/images/bg-dots.png)' }}>
                <div className='fw-container'>
                    <div className="fw-row">
                        <div className="fw-col-xs-12 ">
                            <div className="fw-divider-space"
                            ></div>
                        </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center banner-seo-media-images">
                        <div className='seo-media-images-common'>
                            <img className="top-image-arrow-1" src="/images/Vector-line-straight.png" alt='' />
                            <img className="top-image-arrow-2" src="/images/Vector-line-straight.png" alt='' />
                        </div>

                        <div className='seo-media-images-common'>
                            <img className="top-image-arrow-3" src="/images/Vector-line-straight.png" alt='' />
                            <img className="top-image-arrow-4" src="/images/Vector-line-straight.png" alt='' />
                        </div>
                    </div>

                    <div className="content-under-image banner_vector">
                        <VectorLineDots heading="MODERN TECHNOLOGIES" />

                        <div className="fw-row">
                            <div className="container mt-3">
                                <div className="fw-col-xs-12 d-flex justify-content-center">
                                    <p className="header-main-content">RELIABLE DEVELOPMENT TEAM WITH PROVEN SOLVERS</p>
                                </div>
                                <div className="fw-col-xs-12 ">
                                </div>
                                <div className='d-flex justify-content-center align-items-center' style={{ position: "relative" }}>
                                    <div className='spline_circle_banner' style={{ backgroundColor: isLight ? "#9262c3" : "#283247" }}>
                                    </div>
                                    <div
                                        className="spline-container-banner d-flex justify-content-center align-items-center"
                                    >
                                        {showSpline && (
                                            <Spline
                                                scene="https://prod.spline.design/Hg6BpOrN6fzKa41c/scene.splinecode"
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='top-vector_main mt-5'>
                            <img className="vector-line-common" src="/images/Vector-upper-arrow.png" alt='' />
                            <div className="fw-row">
                                <div className="cector-cross-line-allign">
                                    <div className="vector-class-common">
                                        <div className='dots-first'>
                                            <div className="dot-common"></div>
                                            <div className="dot-common"></div>
                                        </div>
                                        <img className="vector-cross-common" src="/images/vector.png" alt='' />
                                        <div className='dots-second'>
                                            <div className="dot-common"></div>
                                            <div className="dot-common"></div>
                                        </div>
                                    </div>
                                    <div className="fw-heading fw-heading-h2 d-flex justify-content-center align-items-center">
                                        <p className="fw-special-title-building vector-heading">BUILDING &nbsp;
                                            TOMORROW'S &nbsp; SOFTWARE<br /> <span
                                                style={{ fontSize: '24px' }}>TODAY</span>
                                        </p>
                                    </div>
                                    <div className="vector-class-common">
                                        <div className='dots-first'>
                                            <div className="dot-common"></div>
                                            <div className="dot-common"></div>
                                        </div>
                                        <img className="vector-cross-common" src="/images/vector.png" alt='' />
                                        <div className='dots-second'>
                                            <div className="dot-common"></div>
                                            <div className="dot-common"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <img className="vector-line-common1" src="/images/Vector-upper-arrow.png" alt='' />
                        </div>

                        <div className="fw-row" style={{ display: 'flex' }}>
                            <div className="fw-col-xs-12 ">
                                <div className="frame-69-Hp3"
                                    id="playButton"
                                    onClick={handlePlayClick}
                                >
                                    <p className={` ${isLight ? 'scroll-down-Dhh-LIGHT' : 'scroll-down-Dhh'}`}>
                                        Click Here For
                                        Better Experience</p>
                                    <img className="elbskegiex-1-ieT" src={
                                        isLight
                                            ? "/images/ScrollDown-black.gif"
                                            : "/images/ScrollDown.gif"
                                    }
                                        style={{ display: 'block', margin: ' 0 auto' }} alt='' />
                                </div>
                            </div>
                            <audio ref={audioRef} id="audioPlayer" src="/images/audio.mp3" loop></audio>
                        </div>

                        <div className="fw-row">
                            <div className="fw-col-xs-12 ">
                                <div className="fw-divider-space" style={{ marginTop: '24px' }}></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Banner;
